import { GLDistributionTable } from "../GLDistributionTable";
import { TriumphPayTxDetail } from "../TriumphPayTxDetail";
import { Button, Checkbox, DataHeader, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPendingPayAdjustment extends Layout {
    buttonCreateReimbursement: Button;
    buttonSplitAdjustment: Button;
    checkboxEscrowInterest: Checkbox;
    checkboxIsVoid: Checkbox;
    checkboxPayeeExpUsed: Checkbox;
    dataheaderPayAdjustment: DataHeader;
    layoutGLDistribution: GLDistributionTable;
    layoutTriumphPayTxDetail: TriumphPayTxDetail;
    panelDetails: Panel;
    panelEntryMethod: Panel;
    panelSourceCurrency: Panel;
    sourceDrsDeductHist: DataSource;
    sourceDrsPendingDeduct: DataSource;
    sourceJournalDriver: DataSource;
    tabAccounting: Tab;
    tabComments: Tab;
    tabGLDistribution: Tab;
    tabPayDetails: Tab;
    tabTriumphPay: Tab;
    tabsetPayAdjustments: Tabset;
    textboxAccrualGlid: Textbox;
    textboxAdjustmentGlid: Textbox;
    textboxAmount: Textbox;
    textboxBackOfficeReasonCode: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxCurrency: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDeductionType: Textbox;
    textboxDescr: Textbox;
    textboxDriverId: Textbox;
    textboxEmployerTaxLiab: Textbox;
    textboxEnteredDate: Textbox;
    textboxEnteredUserId: Textbox;
    textboxEntryMethod: Textbox;
    textboxExtraPayId: Textbox;
    textboxGlAccrualAmt: Textbox;
    textboxGlAccrualDate: Textbox;
    textboxGlid: Textbox;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
    textboxPayeeId: Textbox;
    textboxProcessStatus: Textbox;
    textboxRate: Textbox;
    textboxReasonCodeComment: Textbox;
    textboxReferenceNo: Textbox;
    textboxShortDesc: Textbox;
    textboxSourceAmount: Textbox;
    textboxSourceCurrency: Textbox;
    textboxSourceId: Textbox;
    textboxStatus: Textbox;
    textboxTaxCode: Textbox;
    textboxTaxType: Textbox;
    textboxTractorId: Textbox;
    textboxTransactionDate: Textbox;
    textboxUnits: Textbox;
    textboxVoidDate: Textbox;
}
